<template>
<div>
    <v-slide-x-reverse-transition>
        <v-alert type="success" class="alert_success" v-if="alert_show_add === true">เพิ่มประเภทวัตถุดิบเรียบร้อย</v-alert>
        <v-alert type="success" class="alert_success" v-if="alert_show_edit === true">แก้ไขประเภทวัตถุดิบเรียบร้อย</v-alert>
    </v-slide-x-reverse-transition>
    <div v-if="loading_page === true">
        <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
            <v-skeleton-loader type="article, actions"></v-skeleton-loader>
        </v-sheet>
    </div>
    <div v-if="loading_page === false">
        <div class="d-flex justify-space-between card_stock_type_list">
            <div class="mr-1">
                <v-form ref="form" @submit.prevent="addStockType()">
                    <div class="mb-2">
                        <h3>{{ edit_id !== null ? 'แก้ไข' : 'เพิ่ม'}}ประเภทวัตถุดิบ</h3>
                    </div>
                    <v-text-field label="ชื่อประเภทวัตถุดิบ" v-model="name" :rules="[v => !!v || 'กรุณากรอกชื่อประเภทวัตถุดิบ']" hide-details="auto" required outlined></v-text-field>
                    <div class="mt-3 mb-3">
                        <div class="d-flex align-center">
                            <div class="mr-1">สามารถเลือกรหัสสีได้ที่นี่</div>
                            <v-input-colorpicker v-model="color" class="colorpicker_stock_type_list" />
                        </div>

                        <v-text-field label="รหัสสี" v-model="color" :rules="[v => !!v || 'กรุณากรอกรหัสสี']" hide-details="auto" required outlined></v-text-field>

                    </div>
                    <v-btn color="#038cc1" class="titlefont_stock_type_list white--text" width="100%" height="50" type="submit">
                        บันทึก
                    </v-btn>
                </v-form>
            </div>
            <div class="ml-1">
                <v-card>
                    <v-card-title>
                        <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
                    </v-card-title>
                    <v-data-table :headers="headers" :items="data" :search="search">
                        <template v-slot:item="dataDetail">
                            <tr>
                                <td>{{dataDetail.item.number}}</td>
                                <td>{{dataDetail.item.name}}</td>
                                <td>
                                    <div class="d-flex align-center">
                                        <div class="mr-1">{{dataDetail.item.color}}</div>
                                        <div class="colordetail_stock_type_list" :style="`background:${dataDetail.item.color}`"></div>
                                    </div>
                                </td>
                                <td>

                                    <span class="edit_data_stock_type_list" @click="detailStockType(dataDetail.item.id)">
                                        <v-icon dark right color="grey">mdi-pencil-box-outline</v-icon>
                                    </span>
                                </td>
                            </tr>
                        </template>
                    </v-data-table>
                </v-card>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import stocktype from '@/api/stock/stocksetting/stocktype.js'
import InputColorPicker from 'vue-native-color-picker'
export default {
    inject: {
        theme: {
            default: {
                isDark: false
            },
        },
    },
    components: {
        "v-input-colorpicker": InputColorPicker
    },
    data() {
        return {
            loading_page: true,
            alert_show_add: false,
            alert_show_edit: false,
            search: '',
            headers: [{
                    text: '#',
                    align: 'start',
                    value: 'number',
                },

                {
                    text: 'ชื่อประเภท',
                    value: 'name'
                },
                {
                    text: 'รหัสสี',
                    value: 'color'
                },
                {
                    text: 'แก้ไข',
                    value: 'action'
                },
            ],
            data: [],
            edit_id: null,
            name: null,
            color: null,
        }
    },
    methods: {
        async stockTypeList() {
            this.loading_page = true
            this.data = []
            stocktype.typeList().then((response) => {
                if (response.data.successful === true) {
                    this.data = response.data.material_type
                    response.data.material_type.forEach((detail, index) => {
                        this.data[index]['number'] = index + 1
                    })
                    this.loading_page = false
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async detailStockType(id) {
            stocktype.detailType(id).then((response) => {
                if (response.data.successful === true) {
                    this.edit_id = response.data.material_type.id
                    this.name = response.data.material_type.name
                    this.color = response.data.material_type.color
                }
            }).catch((error) => {
                if (error.response.status === 401) {
                    this.$store.commit('logOutSuccess')
                    this.$router.push('/login')
                }
            })
        },
        async addStockType() {
            if (this.$refs.form.validate()) {
                this.loading_page = true
                const data = {
                    material_type_name: this.name,
                    material_type_color: this.color,
                }
                if (!this.edit_id) {
                    stocktype.addType(data).then((response) => {
                        if (response.data.successful === true) {
                            this.edit_id = null
                            this.name = null
                            this.color = null
                            this.stockTypeList()
                            this.alert_show_add = true
                            setTimeout(() => this.alert_show_add = false, 5000)
                        }
                    }).catch((error) => {
                        if (error.response.status === 401) {
                            this.$store.commit('logOutSuccess')
                            this.$router.push('/login')
                        }
                    })
                }
                if (this.edit_id) {
                    stocktype.editType(this.edit_id, data).then((response) => {
                        if (response.data.successful === true) {
                            this.edit_id = null
                            this.name = null
                            this.color = null
                            this.stockTypeList()
                            this.alert_show_edit = true
                            setTimeout(() => this.alert_show_edit = false, 5000)
                        }
                    }).catch((error) => {
                        if (error.response.status === 401) {
                            this.$store.commit('logOutSuccess')
                            this.$router.push('/login')
                        }
                    })
                }

            }
        }
    },
    mounted() {
        this.stockTypeList()
    }
}
</script>

<style scoped>
.card_stock_type_list>div:first-child {
    width: 30%;

}

.card_stock_type_list>div:last-child {
    width: 70%;
}

.titlefont_stock_type_list {
    font-size: 22px !important;
}

.edit_data_stock_type_list {
    cursor: pointer;
}

.colorpicker_stock_type_list {
    width: 25px;
}

.colordetail_stock_type_list {
    border-radius: 15px;
    height: 25px;
    width: 25px;
}
</style>
